import React, { useState } from "react";
import "./PricingPlan.css";
import Header from "../../assets/components/01_header/header";
import Footer from "../../assets/components/02_footer/footer";

const pricingPlans = [
  {
    name: "TRIAL WEBSITE",
    description:
      "Get your online presence started with a simple, mobile-friendly single-page website featuring essential contact options.",
    price: "₹0",
    billing: "₹499 monthly retainer",
    buttonText: "GET IN TOUCH",
    features: [
      "Basic single-page website",
      "Free subdomain (optional)",
      "SSL",
      "Contact form",
      "WhatsApp",
      "Mobile responsive",
    ],
  },
  {
    name: "BASIC WEBSITE",
    description:
      "Establish your brand online with a professionally styled single-page website, essential SEO setup, hosting support, and the tools to connect with your audience.",
    price: "₹8,000",
    billing: "₹999 monthly retainer",
    buttonText: "GET IN TOUCH",
    features: [
      "Custom Branding",
      "Single Page Template Development",
      "SEO setup",
      "Blog setup",
      "Forms",
      "Google Analytics",
      "Google Search Console",
      "Monthly maintenance",
    ],
  },
  {
    name: "ESSENTIAL WEBSITE",
    description:
      "Build a stronger digital presence with up to five pages, custom branding, blog functionality, SEO setup, and analytics to support your business growth.",
    price: "₹30,000",
    billing: "₹1,999 monthly retainer",
    buttonText: "GET IN TOUCH",
    popular: true,
    features: [
      "Custom Branding",
      "Up to 5 Pages Template Development",
      "SEO setup",
      "Blog Setup",
      "Forms",
      "Google Analytics",
      "Google Search Console",
      "Monthly maintenance",
    ],
  },
  {
    name: "ADVANCE WEBSITE",
    description:
      "Get a future-rich website with up to 10 pages, custom branding, CRM integration, blog functionality, and essential SEO and website build.",
    price: "₹60,000",
    billing: "₹3,499 monthly retainer",
    buttonText: "GET IN TOUCH",
    features: [
      "Custom Branding",
      "Up to 10 Pages Template Development",
      "SEO setup",
      "Blog Setup",
      "Forms",
      "CRM",
      "Database",
      "Google Analytics",
      "Google Search Console",
      "Monthly maintenance",
    ],
  },
];

const pricingComparisonFeatures = [
  {
    feature: "WEBSITE PAGES",
    trial: "1 Page",
    basic: "1 Page",
    essential: "Up To 5",
    advance: "Up To 10",
  },
  {
    feature: "CUSTOM BRANDING",
    trial: "—",
    basic: "✓",
    essential: "✓",
    advance: "✓",
  },
  {
    feature: "MOBILE RESPONSIVE",
    trial: "✓",
    basic: "✓",
    essential: "✓",
    advance: "✓",
  },
  {
    feature: "FREE SUBDOMAIN (OPTIONAL)",
    trial: "✓",
    basic: "✓",
    essential: "✓",
    advance: "✓",
  },
  {
    feature: "CONTACT FORMS",
    trial: "✓",
    basic: "✓",
    essential: "✓",
    advance: "✓",
  },
  {
    feature: "WHATSAAP INTEGRATION",
    trial: "✓",
    basic: "✓",
    essential: "✓",
    advance: "✓",
  },
  {
    feature: "BLOG SETUP",
    trial: "—",
    basic: "✓",
    essential: "✓",
    advance: "✓",
  },
  {
    feature: "SEO SETUP",
    trial: "—",
    basic: "✓",
    essential: "✓",
    advance: "✓",
  },
  {
    feature: "CRM INTEGRATION",
    trial: "—",
    basic: "—",
    essential: "—",
    advance: "✓",
  },
  {
    feature: "DATABASE INTEGRATION",
    trial: "—",
    basic: "—",
    essential: "—",
    advance: "✓",
  },
  {
    feature: "GOOGLE ANALYTICS",
    trial: "—",
    basic: "✓",
    essential: "✓",
    advance: "✓",
  },
  {
    feature: "GOOGLE SEARCH CONSOLE",
    trial: "—",
    basic: "✓",
    essential: "✓",
    advance: "✓",
  },
];

function PricingPlan() {
  const [selectedPlan, setSelectedPlan] = useState("BASIC WEBSITE");

  return (
    <main className="PricingPlan-Page-Container">
      <Header />
      <section className="PricingPlan-Hero-Section">
        <div className="PricingPlan-Hero-Content-Container">
          <p className="PricingPlan-Hero-Tagline-Text">
            Simple Pricing. Powerful Online Presence.
          </p>

          <h1 className="PricingPlan-Hero-Title-Text">
            Websites That Work as Hard as
            <br />
            Your Business
          </h1>

          <p className="PricingPlan-Hero-Description-Text">
            Get a professional website built around your business goals, without
            the
            <br />
            complexity or uncertainty. Choose a plan that fits your needs, from
            a simple
            <br />
            starter website to a fully customized digital solution.
          </p>
        </div>
      </section>

      <section className="PricingPlan-PricingPlans-Section">
        <div className="PricingPlan-PricingPlans-Cards-Container">
          {pricingPlans.map((plan) => (
            <article
              key={plan.name}
              className={`PricingPlan-PricingPlans-Card-Container ${
                plan.popular
                  ? "PricingPlan-PricingPlans-Card-Container-Popular"
                  : ""
              }`}
            >
              {plan.popular && (
                <div className="PricingPlan-PricingPlans-Popular-Badge-Container">
                  <span className="PricingPlan-PricingPlans-Popular-Badge-Text">
                    MOST POPULAR
                  </span>
                </div>
              )}

              <div className="PricingPlan-PricingPlans-Card-Content-Container">
                <div className="PricingPlan-PricingPlans-Card-Header-Container">
                  <h2 className="PricingPlan-PricingPlans-Card-Title-Text">
                    {plan.name}
                  </h2>

                  <p className="PricingPlan-PricingPlans-Card-Description-Text">
                    {plan.description}
                  </p>
                </div>

                <div className="PricingPlan-PricingPlans-Card-Pricing-Container">
                  <p className="PricingPlan-PricingPlans-Card-Cost-Label-Text">
                    WEBSITE BUILDING COST
                  </p>

                  <h3 className="PricingPlan-PricingPlans-Card-Price-Text">
                    {plan.price}
                  </h3>

                  <p className="PricingPlan-PricingPlans-Card-Billing-Text">
                    {plan.billing}
                  </p>
                </div>

                <div className="PricingPlan-PricingPlans-Card-Button-Container">
                  <button
                    type="button"
                    className="PricingPlan-PricingPlans-Card-Button-Element"
                    onClick={() => window.open("https://wa.me/918976050818", "_blank", "noopener,noreferrer")}
                  >
                    {plan.buttonText}
                  </button>
                </div>

                <div className="PricingPlan-PricingPlans-Card-Features-Container">
                  <ul className="PricingPlan-PricingPlans-Card-Features-List">
                    {plan.features.map((feature) => (
                      <li
                        key={feature}
                        className="PricingPlan-PricingPlans-Card-Feature-Item"
                      >
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="PricingPlan-ComparePlans-Section">
        <div className="PricingPlan-ComparePlans-Content-Container">
          <h2 className="PricingPlan-ComparePlans-Title-Text">
            Compare Our Plans
          </h2>

          <p className="PricingPlan-ComparePlans-Description-Text">
            Explore our website packages side by side to find the right combination of features, flexibility, and ongoing <br className="desktop-break"/> support for your business. Whether you're just starting out or ready to scale, there's a plan for you.
          </p>
        </div>

        <div className="PricingPlan-ComparePlans-Table-Container">
          <div className="PricingPlan-ComparePlans-Table-Element">
            <div className="PricingPlan-ComparePlans-Table-HeaderRow">
              <div className="PricingPlan-ComparePlans-Table-HeaderRow-Flex">
                <div className="PricingPlan-ComparePlans-Table-FeatureHeaderCell">
                  Features
                </div>

                {pricingPlans.map((plan) => (
                  <div
                    key={plan.name}
                    className="PricingPlan-ComparePlans-Table-HeaderCell"
                  >
                    <div className="PricingPlan-ComparePlans-PlanHeader-Container">
                      <h3 className="PricingPlan-ComparePlans-PlanName-Text">
                        {plan.name}
                      </h3>

                      <h4 className="PricingPlan-ComparePlans-PlanPrice-Text">
                        {plan.price}
                      </h4>

                      <button
                        type="button"
                        className="PricingPlan-ComparePlans-PlanButton-Element"
                        onClick={() => setSelectedPlan(plan.name)}
                      >
                        Select
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div>
              {pricingComparisonFeatures.map((item) => (
                <div
                  key={item.feature}
                  className="PricingPlan-ComparePlans-Table-Row"
                >
                  <div className="PricingPlan-ComparePlans-Table-FeatureCell">
                    {item.feature}
                  </div>

                  {pricingPlans.map((plan, index) => {
                    const featureKeys = [
                      "trial",
                      "basic",
                      "essential",
                      "advance",
                    ];

                    return (
                      <div
                        key={plan.name}
                        className={`PricingPlan-ComparePlans-Table-Cell ${
                          selectedPlan && selectedPlan !== plan.name
                            ? "PricingPlan-ComparePlan-Hidden-Mobile"
                            : ""
                        }`}
                      >
                        {item[featureKeys[index]]}
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="PricingPlan-CTA-Section">
        <div className="PricingPlan-CTA-Container">
          <h2 className="PricingPlan-CTA-Title">
            Let's Build a Website That Fits Your Vision
          </h2>

          <p className="PricingPlan-CTA-Description">
            Have a unique idea or need features beyond our standard plans? Let's
            discuss your goals and create a tailored website solution designed
            around your business, audience, and budget.
          </p>

          <button type="button" className="PricingPlan-CTA-Button" onClick={() => window.location.href = "/quotation"}>
            DISCUSS YOUR PROJECT
          </button>
        </div>
      </section>
      <Footer />
    </main>
  );
}

export default PricingPlan;
